// Customer store simplified for Shopify New Customer Accounts (redirect-based)
// No local auth state needed - customers use Shopify's hosted account page

import { SHOPIFY_ACCOUNT_URL } from '@/lib/shopify-customer';

export function openShopifyAccount() {
  window.open(SHOPIFY_ACCOUNT_URL, '_blank');
}
